"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisGlobalState = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const agora_rtc_sdk_ng_1 = __importDefault(require("agora-rtc-sdk-ng"));
class IrisGlobalState {
    constructor() {
        this.streamMessageStreamId = 1;
        this.networkQualityInterval = 2000;
        this.enabledAudio = true;
        this.pausedAudio = false;
        this.pushVideoFrameEnabled = false;
        this.pushVideoFrameUseTexture = false;
        this.pushVideoFrameSourceType = NATIVE_RTC.EXTERNAL_VIDEO_SOURCE_TYPE.ENCODED_VIDEO_FRAME;
        //开启或禁用本地audio功能，audio流
        this.enabledLocalAudio = true;
        this.mutedLocalAudioStream = false;
        //开启或者禁用video功能
        this.enabledLocalVideo = true;
        this.mutedLocalVideoStream = false;
        this.enabledVideo = false;
        this.pausedVideo = false;
        // recording Signal Volume
        this.recordingSignalVolume = 100;
        //
        this.mutedRecordingSignal = false;
        //设置默认 mute 选项
        this.defaultMutedAllRemoteAudioStreams = false;
        this.defaultMutedAllRemoteVideoStreams = false;
        //SetLocalVideoMirrorMode
        this.mirrorMode = NATIVE_RTC.VIDEO_MIRROR_MODE_TYPE.VIDEO_MIRROR_MODE_ENABLED;
        //devicesInfo
        this.playbackDevices = new Array();
        this.recordingDevices = new Array();
        this.videoDevices = new Array();
        //enableAudioVolumeIndication
        this.enableAudioVolumeIndication = false;
        this.enableAudioVolumeIndicationConfig = {
            interval: 50,
            smooth: 3,
            reportVad: false,
        };
        this.channelProfile = NATIVE_RTC.CHANNEL_PROFILE_TYPE.CHANNEL_PROFILE_LIVE_BROADCASTING;
        this.isAudioFrameParametersSet = false;
        this.audioFrameParameters = {
            sampleRate: 32000,
            channel: 1,
            mode: NATIVE_RTC.RAW_AUDIO_FRAME_OP_MODE_TYPE.RAW_AUDIO_FRAME_OP_MODE_READ_ONLY,
            samplesPerCall: 1024,
        };
        //fake
        this.AgoraRTC = agora_rtc_sdk_ng_1.default;
        this.virtualBackgroundEnabled = false;
    }
    reset() {
        this.enabledAudio = true;
        this.pausedAudio = false;
        this.enabledLocalAudio = true;
        this.mutedLocalAudioStream = false;
    }
}
exports.IrisGlobalState = IrisGlobalState;
